import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, message } from "antd";
import "../modal.scss";
import "./index.scss";
import { useTranslation, Trans } from "react-i18next";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { commitOrder, offlinePay } from "@/api/order";
import copy from "copy-to-clipboard";
import { SvgIcon } from "@/components/SvgIcon";

export interface IOfflineModalProps {
  hiddenModal: () => void;
  actionParams: {
    bill?: InvoiceInfo & InvoiceAddress;
    order_ids: string[];
    pay_money: number[];
  };
}
/**
 *
 * 线下转账 modal处理
 */
const Offline: React.FC<IOfflineModalProps> = ({
  hiddenModal,
  actionParams,
}) => {
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const [transactionId, setTransactionId] = useState("");
  //   const [copyStep, setCopyStep] = useState<0 | 1 | 2>(0);
  const [copyStr, setCopyStr] = useState("");
  const copyRef = useRef<HTMLDivElement>(null);

  const getPayNumber = async () => {
    const res = await commitOrder<{ transaction_id: string }>({
      ...actionParams,
    });
    if (res.code === 0) {
      const transaction_id = res.data.transaction_id;
      const offlineRes = await offlinePay({
        transaction_id,
      });
      if (offlineRes.code === 0) {
        setTransactionId(transaction_id);
        setTimeout(() => {
          copy(transaction_id, {
            debug: true,
            message: t("复制支付交易号"),
          });
          //   if (!isCopy) {
          //     messageApi.success(t("复制失败"));
          //     return;
          //   }
          messageApi.success(t("复制成功"));
        }, 0);
      } else {
        messageApi.error({
          content: res.msg,
        });
      }
    } else {
      messageApi.error({
        content: res.msg,
      });
      if (res.code === 200002) {
        location.reload();
      }
    }
  };

  useEffect(() => {
    // if (!copyRef.current) return;
    // const evt = new Event("click", {
    //   bubbles: true,
    //   cancelable: false,
    //   composed: false,
    // });
    // copyRef.current.dispatchEvent(evt);
    // setCopyStr(t("已复制"));
    // setTimeout(() => {
    //   setCopyStr(t(""));
    // }, 5000);
  }, [transactionId, copyRef]);

  return (
    <>
      {contextHolder}
      <Modal
        open
        wrapClassName="modal-wrapper offline-modal-wrapper"
        onCancel={hiddenModal}
        footer={null}
        width="46.667rem"
        centered
        closable
        maskClosable={false}
        title={t("线下汇款")}
      >
        <>
          <section className="offline-info-wrapper">
            <div className="title">{t("转账信息及提示")}</div>
            <div className="item-wrapper">
              <div className="item">
                <span className="title">{t("开户名称")}</span>
                <span className="content">中国图书进出口（集团）有限公司</span>
              </div>
              <div className="item">
                <span className="title">{t("开户银行")}</span>
                <span className="content">中信银行北京东大桥支行</span>
              </div>
              <div className="item">
                <span className="title">{t("银行账号")}</span>
                <span className="content">7111610182200005133</span>
              </div>
            </div>
          </section>
          <section className="requirement-wrapper">
            <div className="title">{t("线下汇款要求")}</div>
            <ul className="requirement-list">
              <li>
                <Trans i18nKey="Transfer_text1">
                  若您确认使用线下汇款的方式支付订单，请
                  <strong>点击获取</strong>下方的支付交易号
                </Trans>
              </li>
              <li>
                <Trans i18nKey="Transfer_text2">
                  在线下汇款时，请您务必在转账备注或交易附言中
                  <strong>填写此支付交易号</strong>，便于我们查询核实
                </Trans>
                {/* {t(
                  "在线下汇款时，请您务必在转账备注或交易附言中填写此支付交易号，便于我们查询核实"
                )} */}
              </li>
              <li>
                {t(
                  "完成线下汇款后，请您及时在publink“个人中心-我的订单”中确认线下汇款信息"
                )}
              </li>
            </ul>
          </section>
          <section className="pay-number-wrapper">
            <div className="title">{t("支付交易号")}</div>

            {transactionId ? (
              <div className="copy-wrapper">
                <span className="number">{transactionId}</span>
                <CopyToClipboard text={transactionId}>
                  <div
                    className="copy"
                    onClick={() => messageApi.success(t("复制成功"))}
                    ref={copyRef}
                  >
                    <SvgIcon icon="icon-fuzhi" width={16} height={16}></SvgIcon>
                  </div>
                </CopyToClipboard>
              </div>
            ) : (
              <div className="btn-wrapper">
                <Button type="primary" onClick={() => getPayNumber()}>
                  {t("获取支付交易号")}
                </Button>
              </div>
            )}
          </section>
        </>
      </Modal>
    </>
  );
};

export default Offline;
